// extracted by mini-css-extract-plugin
module.exports = {"link":"Menu_link__1hJ0p","buttons":"Menu_buttons__2E0j-","buttonsignup":"Menu_buttonsignup__3X8X3","button":"Menu_button__1gepV","buttonsignout":"Menu_buttonsignout__1qjX-"};